import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Button, FormHelperText, Box } from "@mui/material";

const EndPage = () => {
  return (
    <Box sx={{ height: 100, marginBottom: "100px" }}>
      <FormHelperText sx={{ fontSize: "18px",textAlign:"center" }}>
        <Trans i18nKey="global:end_title" />
      </FormHelperText>
    </Box>
  );
};

export default EndPage;
